// Името на езика с главна буква (`uk` → „Украински" на текущия UI език), чрез
// `Intl.DisplayNames`; null, ако не се резолвва.
const displayLanguageName = (code: string, uiLanguage: string): string | null => {
  try {
    const dn = new Intl.DisplayNames([uiLanguage || "bg"], { type: "language" });
    const name = dn.of(code);
    if (name && name.toLowerCase() !== code.toLowerCase()) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
    }
  } catch {
    // Intl.DisplayNames липсва/невалиден код — падаме към кода
  }
  return null;
};

// Човешко име на език с кода в скоби („Украински (uk)"). Пада към главни
// букви на кода, ако не се резолвва.
export const languageLabel = (code: string, uiLanguage: string): string => {
  const name = displayLanguageName(code, uiLanguage);
  return name ? `${name} (${code})` : code.toUpperCase();
};

// Само името („Украински") — за кратки етикети.
export const languageName = (code: string, uiLanguage: string): string =>
  displayLanguageName(code, uiLanguage) ?? code.toUpperCase();
